import { AnimatePresence, motion } from "motion/react";
import type { ReactNode } from "react";

type Props = {
	show: boolean;
	transitionKey: string | number;
	children: ReactNode;
};

export const CollapseFadeTransition: React.FC<Props> = ({
	show,
	transitionKey,
	children,
}) => (
	<AnimatePresence mode="wait" initial={false}>
		{show && (
			<motion.div
				key={transitionKey}
				initial={{ opacity: 0, height: 0 }}
				animate={{ opacity: 1, height: "auto" }}
				exit={{ opacity: 0, height: 0 }}
				transition={{ duration: 0.4, ease: [0.4, 0, 0.2, 1] }}
				style={{ overflow: "hidden" }}
			>
				{children}
			</motion.div>
		)}
	</AnimatePresence>
);
